import type { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

import { createStyleHelper } from '../../../shared/utils/class-names';
import { useWalletTotals } from '../../hooks/use-wallet-totals';
import type { IActivity } from '../../reducers/activity-feed.reducer';
import type { IWallet } from '../../store/account.store';
import { ActivityTable } from '../activity-table/activity-table';
import { InfoBox } from '../info-box/info-box';

import styles from './overview.module.scss';

const style = createStyleHelper(styles, 'overview');

export interface IOverviewProps {
    wallets: IWallet[];
    activityFeed: IActivity[];
    onLoadMoreActivities: () => void;
    hasMoreActivities: boolean;
}

export const Overview: FunctionComponent<IOverviewProps> = ({
    wallets,
    onLoadMoreActivities,
    hasMoreActivities,
    activityFeed,
}) => {
    const intl = useIntl();
    const totals = useWalletTotals(wallets);

    return (
        <>
            <div className={style('balances')}>
                <InfoBox
                    title={intl.formatMessage({
                        id: 'overview.balance.locked',
                        defaultMessage: 'Locked',
                    })}
                    value={intl.formatNumber(totals.locked.value, {
                        style: 'currency',
                        currency: totals.locked.currency,
                    })}
                />
                <InfoBox
                    title={intl.formatMessage({
                        id: 'overview.balance.withdrawable',
                        defaultMessage: 'Withdrawable',
                    })}
                    value={intl.formatNumber(totals.withdrawable.value, {
                        style: 'currency',
                        currency: totals.withdrawable.currency,
                    })}
                />
                <InfoBox
                    title={intl.formatMessage({
                        id: 'overview.balance.bonus',
                        defaultMessage: 'Bonus',
                    })}
                    value={intl.formatNumber(totals.bonus.value, {
                        style: 'currency',
                        currency: totals.bonus.currency,
                    })}
                />
                <InfoBox
                    title={intl.formatMessage({
                        id: 'overview.balance.total',
                        defaultMessage: 'Total',
                    })}
                    value={intl.formatNumber(totals.total.value, {
                        style: 'currency',
                        currency: totals.total.currency,
                    })}
                />
            </div>

            <ActivityTable
                onLoadMore={onLoadMoreActivities}
                hasMore={hasMoreActivities}
                activities={activityFeed}
            />
        </>
    );
};
